import React from "react";
import InfoBox from "../shared/InfoBox";
import List from "../shared/collections/List";
import styles from "../../../src/assets/css/modules/makeAClaim/check-list.css";

const CheckListForClaimBack = ({ content }) => (
  <div className={styles.checkListForClaimBack}>
    <InfoBox
      iconClass={
        content.infoBoxIconClass +
        " " +
        styles.iconStyle +
        " d-none d-sm-block d-xs-block"
      }
    >
      {content.checklistText}
      <List customStyle={styles.listStyle} data={content.checklist} />
      <p id="checklistSla">
        <strong>{content.checklistSLA}</strong>
      </p>
    </InfoBox>
  </div>
);

export default CheckListForClaimBack;
